import Modal from "react-bootstrap/Modal";
import { LoginForgotPassword } from "../components/LoginForgotPassword";

export const LoginForgotPasswordModal = ({
  visible,
  close,
  pageHeaderMsg = null,
}) => {
  return (
    <Modal
      show={visible}
      onHide={close}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton />
      <Modal.Body>
        <LoginForgotPassword close={close} pageHeaderMsg={pageHeaderMsg} />
      </Modal.Body>
    </Modal>
  );
};
